import React from 'react';

function Banner() {
  return (
    <div className="prakerja-banner">
      <div>
        <img alt="" src="/images/header-small.png" />
        <Xicon />
        <img alt="" src="/images/prakerja/prakerjaicon.png" />
      </div>
    </div>
  );
}

const Xicon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 1L1 13" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1 1L13 13" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export default Banner;
